import React, { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { TitledSection } from "../../TitledSection/TitledSection";
import { IBaseTransferListProps } from "../TransferList.props";

export const TransferListLayout: FC<ITransferListLayoutProps> = ({
  availableTitle = "Available",
  selectedTitle = "Selected",
  renderSelectedItemsCount,
  renderAvailableHeaderComponent,
  renderSelectedHeaderComponent,
  availableItems,
  selectedItems,
}) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.transferListLayoutContainer}>
      <TitledSection title={availableTitle}>
        {renderAvailableHeaderComponent}
        {availableItems}
      </TitledSection>
      <TitledSection
        title={selectedTitle}
        endAdornment={renderSelectedItemsCount}
      >
        {renderSelectedHeaderComponent}
        {selectedItems}
      </TitledSection>
    </Box>
  );
};

interface ITransferListLayoutProps extends IBaseTransferListProps {
  availableItems: React.ReactNode;
  selectedItems: React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  transferListLayoutContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: theme.spacing(4),
    flex: 1,
  },
}));
